"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpenseGobdComplianceRules = void 0;
const moment_1 = __importDefault(require("moment"));
const models_1 = require("../models");
const common_1 = require("./common");
const datevValidation_1 = require("./datevValidation");
const expense_utils_1 = require("./expense.utils");
exports.ExpenseGobdComplianceRules = {
    isExpenseStatusReadyForGobdCompliantInvoice: (status) => !!status && [models_1.ExpenseStatusEnum.REVIEWED, models_1.ExpenseStatusEnum.PAID, models_1.ExpenseStatusEnum.DONE].includes(status),
    isInvoiceDateCompliant: (invoiceDate) => !!invoiceDate && (0, moment_1.default)(invoiceDate).isValid(),
    isInvoiceNumberCompliant: (invoiceNumber) => !!invoiceNumber && typeof invoiceNumber === "string" && invoiceNumber.length > 0,
    isVendorGobdCompliant: (expense) => (0, expense_utils_1.isExpenseVendorDefined)(expense),
    isBookingTextCompliant: (description) => !!description && typeof description === "string" && description.length > 0,
    isPostingPeriodCompliant: (postingPeriod) => !!postingPeriod && (0, moment_1.default)(postingPeriod).isValid(),
    isExpenseAccountCompliant: (splits) => (0, common_1.isSet)(splits) && splits.length > 0 && splits.every((s) => { var _a; return (_a = s.expenseAccount) === null || _a === void 0 ? void 0 : _a.accountCode; }),
    isAmountGobdInvoiceCompliant: (expenseAmount, splits, options) => {
        const amountsToCheck = [expenseAmount.totalGrossPrice, expenseAmount.totalNetPrice, expenseAmount.totalTaxPrice];
        if (amountsToCheck.some(common_1.isNotSet)) {
            return false;
        }
        if ((0, common_1.isNotSet)(splits)) {
            return false;
        }
        for (const split of splits) {
            amountsToCheck.push(split.netPrice, split.taxPrice, split.grossPrice);
        }
        if (!amountsToCheck.every((amount) => (0, common_1.isNumeric)(amount))) {
            return false;
        }
        return (0, datevValidation_1.isConsolidatedAmountSafe)(expenseAmount, splits, options);
    },
    isVatGobdInvoiceCompliant: (splits) => (0, common_1.isSet)(splits) && splits.every((s) => { var _a, _b; return (0, common_1.isNumeric)((_b = (_a = s.taxRate) === null || _a === void 0 ? void 0 : _a.taxRate) !== null && _b !== void 0 ? _b : NaN); }),
};
